/**
 * Late-bound root store reference. Feature stores call `getRootStore()` instead of
 * importing `./store` so the module graph stays acyclic (store.ts composes stores).
 *
 * Intentionally untyped here to avoid importing `./store` (which would reintroduce cycles).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let root: any = null

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setRootStore (value: any): void {
  root = value
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getRootStore (): any {
  if (!root) {
    throw new Error('Root store is not initialized yet')
  }
  return root
}
